import AutoBoard from './AutoBoard'
import Board from './Board'
import Caption from './Caption'
import Chart from './Chart'
import DealsTargetBar from './DealsTargetBar'
import DealStats from './DealStats'
import Footer from './Footer'
import Iframe from './Iframe'
import LegendBoard from './LegendBoard'
import MainTitle from './MainTitle'
import Perks from './Perks'
import ProgramLogo from './ProgramLogo'
import UpdatedAt from './UpdatedAt'

export const loyaltyComponents: Map<string, React.ElementType> = new Map([
    ['Board', Board],
    ['Caption', Caption],
    ['Chart', Chart],
    ['DealsTargetBar', DealsTargetBar],
    ['DealStats', DealStats],
    ['MainTitle', MainTitle],
    ['Perks', Perks],
    ['ProgramLogo', ProgramLogo],
    ['Iframe', Iframe],
    ['UpdatedAt', UpdatedAt],
])

export const autoComponents: Map<string, React.ElementType> = new Map([
    ['Board', AutoBoard],
    ['Chart', Chart],
    ['MainTitle', MainTitle],
])

export const legendComponents: Map<string, React.ElementType> = new Map([
    ['Board', LegendBoard],
    ['Caption', Caption],
    ['Iframe', Iframe],
    ['Footer', Footer],
])

export { default as Dashboard } from './Dashboard'
export { default as LegendDashboard } from './LegendDashboard'
